import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  Button,
  BUTTON_THEME,
  BUTTON_SIZE,
  Icon,
} from '@st-operations/uikit/src/v2/index.js'

import FilterMenuItem from './filter-menu-item/index.jsx'
import FilterEditForm from '../filter-edit-form/index.jsx'
import useFiltersCRUD from '../useFiltersCRUD'
import './styles.scss'

const MODAL_STYLES = {
  content: 'add-filters-modal__container',
  childWrapper: 'add-filters-modal__wrapper',
  innerWrapper: 'add-filters-modal__inner-wrapper',
  headerClose: 'add-filters-modal__close-button',
}

const ModalAddFilters = ({ isOpen, onClose }) => {
  const {
    handleSaveChanges,
    handleAddFilter,
    handleEditFilter,
    handleRemoveFilter,
    handleSelectFilter,
    selectedTabIndex,
    isLoading,
    filters,
  } = useFiltersCRUD({
    onSave: onClose,
  })

  return (
    <Modal isOpen={isOpen} onClose={onClose} classes={MODAL_STYLES}>
      <section className="add-filters-modal__content">
        <header className="add-filters-modal__header">
          <h1 className="add-filters-modal__header-title">Add filters</h1>

          <Button
            theme={BUTTON_THEME.GHOST}
            size={BUTTON_SIZE.SMALL}
            onClick={handleAddFilter}
            className="add-filters-modal__header-button"
          >
            <div className="add-filters-modal__button-filter">
              <Icon width="18px" height="18px" icon="add" type="fill" color="currentColor" />
              Add New Filter
            </div>
          </Button>
        </header>
        <div className="add-filters-modal__filters">
          <nav className="add-filters-modal__menu">
            <Choose>
              <When condition={filters?.length > 0}>
                <ul className="add-filters-modal__menu-list">
                  <For each="filter" index="index" of={filters || []}>
                    <li key={index} className="add-filters-modal__menu-item">
                      <FilterMenuItem
                        id={index}
                        attribute={filter.key}
                        operator={filter.operator}
                        value={filter.value}
                        isSelected={selectedTabIndex === index}
                        onClick={handleSelectFilter}
                        onDelete={handleRemoveFilter}
                      />
                    </li>
                  </For>
                </ul>
              </When>
              <Otherwise>
                <p className="add-filters-modal__empty-menu">
                  Start adding your filters and they will appear here
                </p>
              </Otherwise>
            </Choose>
          </nav>
          <div className="add-filters-modal__form">
            <Choose>
              <When condition={filters?.length > 0}>
                <FilterEditForm
                  key={selectedTabIndex}
                  id={selectedTabIndex}
                  attribute={filters[selectedTabIndex]?.key}
                  operator={filters[selectedTabIndex]?.operator}
                  value={filters[selectedTabIndex]?.value}
                  hasHeader={filters[selectedTabIndex]?.hasHeader}
                  onEdit={handleEditFilter}
                />
              </When>
              <Otherwise>
                <div className="add-filters-modal__empty">
                  <img src="../../../../../../static/img/Empty.svg" />
                  <p className="add-filters-modal__no-filters">No filters yet</p>
                </div>
              </Otherwise>
            </Choose>
          </div>
        </div>
        <footer className="add-filters-modal__footer">
          <Button
            isLoading={isLoading}
            className="add-filters-modal__footer-button"
            onClick={handleSaveChanges}
          >
            Save Changes
          </Button>
        </footer>
      </section>
    </Modal>
  )
}

ModalAddFilters.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

ModalAddFilters.defaultProps = {
  isOpen: false,
  onClose: () => {},
}

export default React.memo(ModalAddFilters)
